<template>
    <div id="app">
        <AppNavbar />
        <HelloWorld />
        <FeedBack />
    </div>
</template>

<script>
    import axios from 'axios';
    import HelloWorld from './components/HelloWorld.vue';
    import AppNavbar from './components/nav.vue';
    import FeedBack from './components/feedback.vue';

    export default {
        name: 'App',
        components: {
            HelloWorld,
            AppNavbar,
            FeedBack
        },
        deta() {
            return {
                login_accessToken: '',
                user_accessToken: '',
                loginCode: ''
            }
        },
        computed: {

        },
        created() {
            this.getLogin()
        },
        methods: {
            getLogin() {
                let uat = localStorage.getItem('user_accessToken');
                if(uat) {
                    this.user_accessToken = uat;
                    this.getUserInformation();
                } else {
                    let code = this.$utils.getQueryParam('code');

                    if(code!== null) {
                        this.loginCode = code;
                        this.getLoginToken();
                    } else {     
                        let cookieToken;
                        if(this.$config.debugMode) {
                            cookieToken = this.$store.state.login_token;
                        } else {
                            cookieToken = this.$utils.getCookie('SSOSYSaccessToken');
                        }
                        
                        if(cookieToken){
                            this.isLogin(cookieToken);
                        } else {
                            // this.postMatomo(false);
                        }         
                    }
                }
            },
            isLogin(token) {
                this.login_accessToken = token;
                let fd  = new FormData();
                fd.append('accessToken', token);
                // ,{
                //     headers: {
                //         'Content-Type' : 'application/x-www-form-urlencoded'
                //     }
                // }
                axios.post(this.$config.loginBaseUrl + 
                '/onon/openapi/auth/checkAuth',fd
                ).then(res => {
                    if(res.data.code == 200) {
                        this.cookieGetCode();
                    } else if (res.data.code == 40001) {
                        this.$store.dispatch('logout');
                        this.$Message.warning('warning', '登录已过期请重新登录');
                        return;
                    } else {
                        this.$store.dispatch('logout');
                        return;
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            cookieGetCode() {
                let fd = new FormData();
                fd.append('accessToken', this.login_accessToken);
                fd.append('client_id', this.$config.loginClientID);
                fd.append('redirect_uri', this.$config.loginRedirectURL);
                fd.append('state', '1234');
                axios.post(this.$config.loginBaseUrl + 
                '/onon/openapi/auth/authorized',fd,{
                        headers: {
                            'Content-Type' : 'application/x-www-form-urlencoded'
                        }
                }).then( res => {
                    // console.log(res);
                    if(res.data.success) {
                        this.loginCode = res.data.result.code;
                        this.getLoginToken();
                    } else {
                         this.$store.dispatch('logout');
                        return;
                    }
                }).catch(err => {
                    console.log(err)
                });
            },
            getUserInformation() {
                axios.get(this.$config.loginBaseUrl + 
                '/onon/openapi/auth/user?access_token=' + this.$store.getters.userToken)
                .then(res => {  
                // console.log('getUserInformation',res);
                if(res.data.code == 200) {
                    this.$store.dispatch('login', {
                        token: '',
                        userInfo: res.data.result
                    })
                    
                    if(res.data.result.ou.is_new_order_user == 'new_user')
                    this.$store.dispatch('setNewUser', true)

                    this.$utils.deleteQueryParam('code');
                    this.$utils.deleteQueryParam('state');
                    this.$utils.deleteQueryParam('accessToken');

                } else if(res.data.code === 40002){
                     this.$store.dispatch('logout');
                } else if(res.data.code === 40003){
                     this.$store.dispatch('logout');
                } else if(res.data.code === 40001){
                    let cookieToken = this.$utils.getCookie('SSOSYSaccessToken');
                    // console.log(cookieToken);
                    if(cookieToken){
                        this.isLogin(cookieToken);
                    } else {
                        this.$Message.warning('warning', '登录已过期请重新登录');
                        this.$store.dispatch('logout');
                    }
                } else {
                    this.$store.dispatch('logout');
                }
                }).catch(err => {
                    console.log(err);
                })
            },
            getLoginToken() {
                axios.get(this.$config.loginBaseUrl + '/onon/openapi/auth/token'+ '?code=' + 
                    this.loginCode + '&client_id='+ 
                    this.$config.loginClientID +
                    '&response_type=code&grant_type=authorization_code&client_secret=' + 
                    this.$config.loginClientSecret +'&redirect_uri=' + 
                    this.$config.loginRedirectURL).then( res => {
                    // console.log('getLoginToken',res);
                
                    if(res.data.success) {
                        this.$store.dispatch('setToken', {
                            user_token: res.data.result.access_token
                        })
                        // this.$store.state.user_accessToken = res.data.result.access_token;
                        this.getUserInformation();
                    } else {
                        this.$Message.warning(res.data.message);
                        this.$utils.deleteQueryParam('code');
                        this.$utils.deleteQueryParam('state');
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        },
        mounted() {
        }
    };
</script>

<style>
    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    :root {
        --header-theme-color: #a364ff;
        --htc-btn-hover: #6c35de;
        --border-color: #daefe9;
        --main-theme-color: #1fb8df;
        --main-theme-hover-color: #2da0bd;
        --theme-btn-hover-color: #ddd;
        --main-bg-color: #f6f7f9;
        --text-highlight-color: #fee972;
        --user-page-item-color: #d5ecf3;
        --user-page-item-icon-color: #14a7cd;
        --foot-text-color: #616161;
        --user-text-color: #515a6e;
    }

    .row-col-2 {
        display: flex;
        flex-wrap: wrap;
    }

    .row-col-2>* {
        flex: 0 0 50%;
        max-width: 50%;
    }

    .app-btn{
    background-image: linear-gradient(to right, #6c35de, #a364ff);
    border: none;
    width: 100%;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 600;
    } 
</style>
